export { default as compose } from "lodash/flowRight";

import seedrandom from "seedrandom";

export function getLastStringParamFromUrl(index = 1, param = "id") {
    let id = "";
    if (typeof window !== "undefined") {
        if (window.location.search) {
            id = new URL(location.href).searchParams.get(param) || "";
        } else {
            const urlByParts = window.location.pathname.split("/");
            id = urlByParts[urlByParts.length - index];
        }
    }
    return id;
}

export function randomIntFromInterval(seed, min, max) {
    // min and max included
    return Math.floor(seedrandom(seed)() * (max - min + 1) + min);
}
